






























































































































































import Vue from 'vue';

const locationHost = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

export default Vue.extend({
  name: 'widgets',
  data() {
    return {
      widgets: [
        {
          id: 'oneColumn',
          type: 'Embed',
          name: 'One Column',
          hostedLinkBase: null,
          tags: ['webview', 'widget'],
          iframeProperties: {
            width: '288',
            height: '625',
          },
          parameters: {
            widgetLayout: '1-col',
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
        {
          id: 'oneColumnShort',
          type: 'Embed',
          name: 'One Column Short',
          hostedLinkBase: null,
          tags: ['webview', 'widget'],
          iframeProperties: {
            width: '288',
            height: '475',
          },
          parameters: {
            widgetLayout: '1-col-short',
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
        {
          id: 'oneColumnCondensed',
          type: 'Embed',
          name: 'One Column Condensed',
          hostedLinkBase: null,
          tags: ['webview', 'widget'],
          iframeProperties: {
            width: '288',
            height: '320',
          },
          parameters: {
            widgetLayout: '1-col-condensed',
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
        {
          id: 'twoColumn',
          type: 'Embed',
          name: 'Two Column',
          hostedLinkBase: null,
          tags: ['webview', 'widget'],
          iframeProperties: {
            width: '576',
            height: '345',
          },
          parameters: {
            widgetLayout: '2-col',
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
        {
          id: 'threeColumn',
          type: 'Embed',
          name: 'Three Column',
          hostedLinkBase: null,
          tags: ['widget'],
          iframeProperties: {
            height: '625',
          },
          parameters: {
            widgetLayout: '3-col',
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
        {
          id: 'widgetStyling',
          type: 'Embed',
          name: 'Widget Styling',
          hostedLinkBase: null,
          tags: ['widget', 'webview'],
          iframeProperties: {
            width: '288',
            height: '625',
          },
          parameters: {
            widgetLayout: '3-col',
            primaryColor: 'F00',
            primaryFontColor: 'F00',
            primaryButtonFontColor: 'FFF',
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
        {
          id: 'quickLink',
          type: 'Link',
          name: 'Quick Link Hosted Page',
          hostedLinkBase: '',
          tags: ['hosted'],
          iframeProperties: {
            height: '800',
          },
          parameters: {
            mall: 'pla',
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
        {
          id: 'reservationDetails',
          type: null,
          name: 'Reservation Details Hosted Page',
          hostedLinkBase: 'reservation-details',
          tags: ['hosted'],
          iframeProperties: {
            height: '800',
          },
          parameters: {
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
        {
          id: 'modifyReservation',
          type: null,
          name: 'Modify Reservation Hosted Page',
          hostedLinkBase: 'manage-reservations',
          tags: ['hosted'],
          iframeProperties: {
            height: '1100',
          },
          parameters: {
            apiKey: '9de8180c-71a1-5145-adae-2e889acae20e',
            customerId: '5',
            occupantTypeId: '11',
          },
        },
      ],
    };
  },
  methods: {
    copyText(textSel: string) {
      /* Get the text field */
      const copyText = document.getElementById(textSel) as HTMLInputElement;

      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand('copy');
    },
  },
  computed: {
    iframeDetails() {
      return (this as any).widgets.reduce((accum: any, widgetDefinition: any): any => {
        const srcParamsString = Object.keys(widgetDefinition.parameters)
          .map((key) => `${key}=${widgetDefinition.parameters[key]}`)
          .join('&');

        const iframePropsString = Object.keys(widgetDefinition.iframeProperties)
          .map((key) => `${key}=${widgetDefinition.iframeProperties[key]}`)
          .join(' ');

        const baseLink = widgetDefinition.hostedLinkBase !== null ? `${locationHost}/${widgetDefinition.hostedLinkBase}` : `${locationHost}/widget`;

        accum[widgetDefinition.id] = {
          src: `${baseLink}?${srcParamsString}`,
          fullEmbed: `<iframe ${iframePropsString} src='${baseLink}?${srcParamsString}'></iframe>`,
        };

        return accum;
      }, {} as any);
    },
  },
});
